import { Checkbox } from "@/components/ui/checkbox"
import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { useEffect, useState } from "react";



export function CheckboxRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<string[]>([]);

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        if (!disabled && setFormValue) {
            setFormValue(value.join(','));
        }
    }, [setFormValue, value, disabled]);

    if (!Array.isArray(question.field_options)) {
        return (
            <div className="flex flex-col flex-wrap gap-2">
                {question.field_options?.options?.map((option) => {
                    if (typeof option === 'string') {
                        option = {
                            value: option,
                            label: option
                        }
                    }
                    return (
                        <div key={option.value} className="flex items-center space-x-2">
                            <Checkbox
                                id={option.value}
                                value={option.value}
                                checked={!disabled ? value.includes(option.value) : response?.field_value?.includes(option.value)}
                                onClick={() => {
                                    if (value.includes(option)) {
                                        setValue(value.filter(val => val !== option.value));
                                    } else {
                                        setValue([...value, option.value]);
                                    }
                                }}
                                disabled={disabled}
                                className="w-5 h-5 form-checkbox text-primary"
                            />
                            <label htmlFor={option.value} className="text-sm">{option.label}</label>
                        </div>
                    )
                })}
            </div>
        )
    }
    return (
        <div className="flex flex-col flex-wrap gap-2">
            {question.field_options?.options?.map((option) => {
                if (typeof option === 'string') {
                    option = {
                        value: option,
                        label: option
                    }
                }
                return (
                    <div key={option.value} className="flex items-center space-x-2">
                        <Checkbox
                            id={option.value}
                            value={option.value}
                            checked={!disabled ? value.includes(option.value) : response?.field_value?.includes(option.value)}
                            onClick={() => {
                                if (value.includes(option)) {
                                    setValue(value.filter(val => val !== option.value));
                                } else {
                                    setValue([...value, option.value]);
                                }
                            }}
                            disabled={disabled}
                            className="w-5 h-5 form-checkbox text-primary"
                        />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                    </div>
                )
            })}
        </div>
    )
}